module.exports = __webpack_public_path__ + "static/img/wuliusudi_active.60a75ffc.png";